const { SET_IS_SAFARI } = require("./constants");

export const setIsSafari = (isSafari) => ({
  type: SET_IS_SAFARI,
  payload: isSafari,
});
